import {useEffect, useState, useRef} from "preact/hooks";
import { createContext } from "preact";

const ThemeContext = createContext(null);

const DEFAULT_VARIABLES = {
  "--primary-color-500": "#3F51B5",
  "--primary-color-700": "#303F9F",
  "--primary-color-900": "#1A237E"
};

const ThemeContextProvider = ({children, variables = {}}) => {
  const [_variables, _setVariables] = useState({...DEFAULT_VARIABLES, ...variables});
  const node = useRef(null);

  useEffect(() => {
    updateCSSVariables(_variables);
  }, [_variables]);

  const setVariables = (v) => {
    _setVariables(v);
  };

  const updateCSSVariables = (v) => {
    Object.entries(v).forEach(([prop, value]) => node.current.style.setProperty(prop, value));
  };

  return <ThemeContext.Provider value={{_variables, setVariables}}>
    <div ref={node}>
      {children}
    </div>
  </ThemeContext.Provider>;
};

export default ThemeContextProvider;



// WEBPACK FOOTER //
// ./contexts/ThemeContext.js